export default __webpack_public_path__ + "images/nvidia-logo.9276f21440236ab5fcfb73972d2dd6a4.png";